import React, { Component, Fragment } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import GameTab from "./gametab";
import RightGameTab from "./rightgametab";
import "./home.css";
import gameImage from "../../style/images/home/test image.png";

import { Tabs, List, Row, Col, Card } from "antd";
import "antd/dist/antd.css";
const TabPane = Tabs.TabPane;

export default class Home extends Component {
  render() {
    return (
      <Fragment>
        <Header {...this.props}/>
        
        <div className="practice">
          <h1>PRACTICE. ENTER. PLAY. WIN</h1>
        </div>

       <GameTab/>
       <RightGameTab/>
       <GameTab/>
        <Footer />
      </Fragment>
    );
  }
}
